export default {
  headerContent: {
    title: 'Ray Sigorta Kasko Sigortası Teklifi Hesaplama',
    slogan: "Araç Kasko Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ARAÇ KASKO SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Ray Sigorta Araç Kasko Sigortası',
    description: {
      title: 'Ray Sigorta Araç Kasko Sigortası Nedir? ',
      content: [
        'Ray Sigorta güvencesi ile aracınızı hırsızlıktan kaza sonucu oluşacak hasarlara kadar güvence altına alabilirsiniz.',
        'Araba sigortasının fiyatını karşılaştırdığınızda, ihtiyacınız olan sigortayı karşılayabileceğiniz bir fiyata alabilmeniz için her seçeneği araştırmanız önemlidir.',
        'Çevrimiçi kasko sigortası teklifi alarak en iyi otomobil sigortası fiyatlarını aramaya başlayın!'
      ]
    },
    subContent: {
      title: 'Ray Sigorta Araç Kasko Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Kasko sigortası teminatları aldığınız poliçe paketine göre değişmektedir.',
          subList: [
            'Çarpma ve çarpışma',
            'Yangın',
            'Hırsızlık',
            'İMM (ihtiyari Mali Mesuliyet)',
            'Koltuk ferdi kaza tedavi masrafları',
            'Yol yardım hizmetleri',
            'Mini onarım hizmetlerini kapsamaktadır.',
            'Doğal afetler',
            'Terör',
            'Kişisel eşya',
            'Yurt dışı teminatı',
            'Anahtar kaybı',
            'Yanlış akaryakıt dolumu',
            'Ek aksesuar',
            'Kemirgen hayvan zararları',
            'Anahtar ile çalınma teminatından oluşmaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Araç Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Araç Kasko Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Araç Kasko Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Turk Nippon Sigorta Araç Kasko Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
